import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { DropDownList, DropDownListModel } from '@syncfusion/ej2-dropdowns';

import { routes } from '@/shared/routes';
import { EditableClientProps } from '@/shared/types/editable';
import { appendQuery } from '@/shared/utils/url';

import { controlModel } from '@/front/editable/control';
import { input } from '@/front/editable/input';
import { addValidation, setControl } from '@/front/editable/state';
import { change } from '@/front/editable/utils';

export const initDropDownList = (p: EditableClientProps, e: HTMLElement) => {
  const dropDownList = new DropDownList({
    ...dropDownlistModel(p),
    change: change(e),
  });

  dropDownList.appendTo(input(p, e));

  setControl(p.id, dropDownList);

  addValidation(p, e);
};

export const dropDownlistModel = (
  p: EditableClientProps,
  options?: { multiselect?: boolean },
): DropDownListModel & { value?: string } => ({
  ...controlModel(p),
  dataSource: p.lookup
    ? new DataManager({
        url: appendQuery(routes.data.lookup.list({ model: p.lookup }), {
          ...(!p.validation?.required && !options?.multiselect
            ? { includeEmpty: 'true', emptyText: p.emptyText }
            : undefined),
          ...(p.includeArchived ? { includeArchived: 'true' } : undefined),
          ...(p.filter ? { filter: JSON.stringify(p.filter) } : undefined),
        }),
        adaptor: new UrlAdaptor(),
      })
    : p.options,
  fields: {
    value: 'value',
    text: 'text',
  },
  allowFiltering: p.allowFiltering,
  filterType: p.allowFiltering ? 'Contains' : undefined,
  placeholder:
    p.placeholder ?? (p.defaultValue ? p.options?.find((option) => option.value === p.defaultValue)?.text : undefined),
  showClearButton: false,
  popupHeight: '400px',
});
